import { useParams } from "react-router-dom";
import useClientPlants from "./useClientPlants";

/**
 * The plant the current route points at (`:plantId`), with its record
 * resolved from the visible plants list. Stateless - everything is derived
 * from the URL and useClientPlants on each render, so there is exactly one
 * copy of this state and it can never drift out of sync.
 */
export default function useRoutePlant() {
  const { plantId } = useParams();
  const { plants, loading: plantsLoading } = useClientPlants();
  const plant =
    plants?.find((p) => String(p.id) === String(plantId)) || { id: plantId };

  return { plantId, plant, plants, plantsLoading };
}
